<irembogov-fb-toolbar
  (toggleOutline)="onToggleOutline()"></irembogov-fb-toolbar>
<div class="fb-canvas-wrapper" style="position: relative">
  <irembogov-fb-form-outline
    [visible]="showOutline"></irembogov-fb-form-outline>

  <ng-container *ngIf="builderMode === 'builder'">
    <div class="fb-canvas" (click)="onCanvasClick()">
      <div
        class="fb-canvas__sections"
        [sortablejs]="sections"
        [sortablejsOptions]="sectionSortableOptions">
        <irembogov-fb-section
          *ngFor="
            let section of sections;
            let si = index;
            trackBy: trackBySectionKey
          "
          [section]="section"
          [sectionIndex]="si"
          [selectedFieldKey]="selectedFieldKey"
          (fieldSelected)="onFieldSelected($event)"
          (sectionChanged)="onFormChanged()"
          (deleteSection)="onDeleteSection($event)">
        </irembogov-fb-section>
      </div>

      <div class="fb-canvas__empty" *ngIf="sections.length === 0">
        <i class="fa-solid fa-layer-group fb-canvas__empty-icon"></i>
        <p>No sections yet. Add a section to start building your form.</p>
      </div>

      <button
        class="fb-canvas__add-section-btn"
        (click)="onAddSection(); $event.stopPropagation()">
        <i class="fa-solid fa-plus"></i> Add Section
      </button>
    </div>
  </ng-container>

  <ng-container *ngIf="builderMode === 'preview'">
    <div class="fb-canvas fb-canvas--preview">
      <div class="fb-canvas__preview-bar">
        <span class="fb-canvas__preview-bar-label">
          <i class="fa-solid fa-eye"></i> Preview
        </span>
        <button
          class="btn btn-sm btn-outline-primary"
          (click)="onExitPreview()">
          <i class="fa-solid fa-arrow-left"></i> Back to Builder
        </button>
      </div>
      <div class="fb-canvas__preview-body">
        <form [formGroup]="previewForm">
          <formly-form
            [form]="previewForm"
            [model]="previewModel"
            [fields]="previewFields"
            [options]="previewOptions"></formly-form>
        </form>
        <div
          class="fb-canvas__preview-empty"
          *ngIf="!previewFields || previewFields.length === 0">
          Nothing to preview yet. Add fields in the builder first.
        </div>
      </div>
    </div>
  </ng-container>

  <irembogov-fb-context-menu></irembogov-fb-context-menu>
</div>
